"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hr = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const helpers_1 = require("../helpers");
const useStyles = styles_1.makeStyles(theme => ({
    container: {
        ...helpers_1.responsivePadding(theme),
        height: 1,
        width: '100%',
        backgroundColor: theme.palette.divider,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(3),
    },
}));
const Hr = () => {
    const classes = useStyles();
    return react_1.default.createElement(core_1.Box, { className: classes.container });
};
exports.Hr = Hr;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSHIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29tcG9uZW50cy9Ici50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsa0RBQWtDO0FBQ2xDLDRDQUF3QztBQUN4QyxxREFBc0Q7QUFDdEQsd0NBQStDO0FBRS9DLE1BQU0sU0FBUyxHQUFHLG1CQUFVLENBQUMsS0FBSyxDQUFDLEVBQUUsQ0FBQyxDQUFDO0lBQ3JDLFNBQVMsRUFBRTtRQUNULEdBQUcsMkJBQWlCLENBQUMsS0FBSyxDQUFDO1FBQzNCLE1BQU0sRUFBRSxDQUFDO1FBQ1QsS0FBSyxFQUFFLE1BQU07UUFDYixlQUFlLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxPQUFPO1FBQ3RDLFNBQVMsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztRQUMzQixZQUFZLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7S0FDL0I7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVHLE1BQU0sRUFBRSxHQUFPLEdBQUcsRUFBRTtJQUN6QixNQUFNLE9BQU8sR0FBRyxTQUFTLEVBQUUsQ0FBQztJQUM1QixPQUFPLDhCQUFDLFVBQUcsSUFBQyxTQUFTLEVBQUUsT0FBTyxDQUFDLFNBQVMsR0FBSSxDQUFDO0FBQy9DLENBQUMsQ0FBQztBQUhXLFFBQUEsRUFBRSxNQUdiIn0=